import React, { useRef, useState } from "react";
import { Grid, Row, Col, FormControl, ControlLabel } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import "./AddCataloguePackageDetailsForm.css";
import Select from "react-select";
import Button from "components/CustomButton/CustomButton.jsx";
import AddCataloguePackageFeatureDetailsForm from "./addCataloguePackageFeatureDetails";
const CreateCataloguePackageDetailsForm = (props) => {
  const {
    countryData,
    groupData,
    packageLogo,
    isEditMode,
    featureDetails,
    setFeatureDetails,
    addSpecialtyRow,
    onChangeTags,
    onChangeTier,
    tagListOption,
    couponList,
    packageName,
    setPackageName,
    productCode,
    setProductCode,
    userType,
    setUserType,
    packageType,
    setPackageType,
    isFeatured,
    setIsFeatured,
    freeTrialType,
    setFreeTrialType,
    freeTrial,
    setFreeTrial,
    duration,
    setDuration,
    discountPrice,
    setDiscountPrice,
    durationType,
    setDurationType,
    setCountry,
    country,
    uploadPackageLogo,
    handlePackageLogoFileChange,
    specialtyListOption,
    doctorListOption,
    onSpecialityChange,
    onCallChange,
    handleAllCheckedFreeDelivery,
    deliveryWelcomeNote,
    setDeliveryWelcomeNote,
    noOfFreeDelivery,
    setNoOfFreeDelivery,
    noOfFreeValue,
    setNoOfFreeValue,
    tags,
    selectedTiers,
    selectedTags,
    setSelectedTiers,
    setSelectedTags,
    onCouponAdd,
    onRemoveCoupon,
    onGroupAdd,
    onGroupRemove,
    updateClaimField,
    updatePolicyField,
    toggleClaimCheckbox,
    onDoctorChange,
    onDoctorCallChange,
    addDoctorRow,
    removeDoctorRow,
    removeSpecialtyRow,
    onSubmit,
    packagePrice,
    setPackagePrice,
    processing,
    packageNameError,
    packageDurationError,
    packagePriceError,
    countryError,
    claimValueError,
    bankChargeError,
    brokerEmailError,
    ipdClaimValueError,
    setCountryError,
    setPackageNameError,
    setPackageDurationError,
    setPackagePriceError,
    setClaimValueError,
    isLoading,
    onCallUnlimitedChange,
    packageLogoError,
    packageLogoUrl,
    packageNameRef,
    countryRef,
    packageLogoRef,
    pricingRef,
    featureDetailsRef,
    durationRef,
    setFeatureError,
    featureError,
  } = props;

  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <Card
              content={
                <form className="package-details-form">
                  <div className="form-section" ref={packageNameRef}>
                    <div className="catalogue-section-header">
                      <h4>
                        <i className="fa fa-tag"></i>
                        Basic Information
                      </h4>
                    </div>
                    <div className="section-content">
                      <div className="form-row">
                        <div className="form-group-custom">
                          <label>
                            Type <span className="required">*</span>
                          </label>
                          <select
                            className="react-select primary form-control"
                            name="user_type"
                            value={userType}
                            onChange={(e) => setUserType(e.target.value)}
                          >
                            <option value="1">B2B</option>
                            <option value="2">B2C</option>
                            <option value="3">B2B2C</option>
                          </select>
                        </div>
                        <div className="form-group-custom">
                          <label>
                            Basic Type <span className="required">*</span>
                          </label>
                          <select
                            className="react-select primary form-control"
                            name="package_type"
                            value={packageType}
                            onChange={(e) => setPackageType(e.target.value)}
                          >
                            <option value="1">Normal</option>
                            <option value="2">Basic</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group-custom" ref={packageNameRef}>
                          <label>
                            Package Name <span className="required">*</span>
                          </label>
                          <FormControl
                            type="text"
                            placeholder="Enter package name"
                            className="form-control"
                            value={packageName}
                            onChange={(e) => {
                              setPackageName(e.target.value);
                              setPackageNameError(null);
                            }}
                          />
                          {packageNameError && (
                            <div className="error-message">
                              {packageNameError}
                            </div>
                          )}
                        </div>
                        <div className="form-group-custom">
                          <label>Product Code</label>
                          <FormControl
                            type="text"
                            placeholder="Enter product code"
                            className="form-control"
                            value={productCode}
                            onChange={(e) => setProductCode(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group-custom" ref={countryRef}>
                          <ControlLabel>
                            Country <span className="required">*</span>
                          </ControlLabel>
                          <Select
                            options={
                              countryData &&
                              countryData.map((country) => ({
                                value: country.country_code,
                                label: country.country_name,
                              }))
                            }
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select Country"
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                            value={country}
                            onChange={(selectedOption) => {
                              setCountry(selectedOption);
                              setCountryError(null);
                            }}
                          />
                          {countryError && (
                            <div className="error-message">{countryError}</div>
                          )}
                        </div>
                        <div className="form-group-custom" ref={packageLogoRef}>
                          <ControlLabel>
                            Package Logo <span className="required">*</span>
                          </ControlLabel>
                          <input
                            style={{ display: "none" }}
                            id="selectpackage_logo"
                            type="file"
                            className="form-control"
                            name="package_logo"
                            accept="image/*"
                            onChange={handlePackageLogoFileChange}
                          />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <Button
                              onClick={uploadPackageLogo}
                              style={{ color: "#2B3A41" }}
                            >
                              <i
                                className={
                                  packageLogo || packageLogoUrl
                                    ? "fa fa-pencil fa-fw"
                                    : "fa fa-plus"
                                }
                              ></i>{" "}
                              {packageLogo
                                ? "Change Package Logo"
                                : packageLogoUrl
                                  ? "Update Package Logo"
                                  : "Choose Package Logo"}
                            </Button>
                            {packageLogo && (
                              <span
                                style={{
                                  color: "#5cb85c",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                ✓ New logo selected
                              </span>
                            )}
                            {packageLogoUrl && !packageLogo && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "25px",
                                }}
                              >
                                <img
                                  src={packageLogoUrl}
                                  alt="Package Logo"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "25px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          {packageLogoError && (
                            <div
                              className="error-message"
                              style={{ marginTop: "8px" }}
                            >
                              {packageLogoError}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group-custom checkbox-group">
                          {userType === "2" ? (
                            <div className="form-row">
                              <div className="form-group-custom">
                                <label>Show in Mobile App</label>
                                <div className="radio-group">
                                  <label>
                                    <input
                                      type="radio"
                                      name="is_featured"
                                      value="1"
                                      checked={isFeatured === "1"}
                                      onChange={(e) =>
                                        setIsFeatured(e.target.value)
                                      }
                                    />
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name="is_featured"
                                      value="0"
                                      checked={isFeatured === "0"}
                                      onChange={(e) =>
                                        setIsFeatured(e.target.value)
                                      }
                                    />
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-section" ref={pricingRef}>
                    <div className="catalogue-section-header">
                      <h4>
                        {/* <i className="fa fa-dollar"></i> */}
                        Pricing Details
                      </h4>
                    </div>
                    <div className="section-content">
                      <div className="form-row">
                        <div className="form-group-custom">
                          <label>
                            Package Price <span className="required">*</span>
                          </label>
                          <FormControl
                            type="number"
                            className="form-control"
                            placeholder="Enter price"
                            min="0"
                            onKeyPress={(e) => {
                              if (
                                e.key === "-" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={packagePrice}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || parseFloat(value) >= 0) {
                                setPackagePrice(value);
                                setPackagePriceError(null);
                              }
                            }}
                          />
                          {packagePriceError && (
                            <div className="error-message">
                              {packagePriceError}
                            </div>
                          )}
                        </div>
                        <div className="form-group-custom">
                          <label>Discount Price</label>
                          <FormControl
                            type="number"
                            className="form-control"
                            placeholder="Enter discount price"
                            value={discountPrice}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || parseFloat(value) >= 0) {
                                setDiscountPrice(value);
                              }
                            }}
                            min="0"
                            onKeyPress={(e) => {
                              if (
                                e.key === "-" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group-custom" ref={durationRef}>
                          <label>
                            Duration <span className="required">*</span>
                          </label>
                          <FormControl
                            type="number"
                            className="form-control"
                            placeholder="Enter duration"
                            value={duration}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || parseFloat(value) > 0) {
                                setDuration(value);
                                setPackageDurationError(null);
                              }
                            }}
                            min="1"
                            onKeyPress={(e) => {
                              if (
                                e.key === "-" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {packageDurationError && (
                            <div className="error-message">
                              {packageDurationError}
                            </div>
                          )}
                        </div>
                        <div className="form-group-custom">
                          <label>
                            Duration Type <span className="required">*</span>
                          </label>
                          <select
                            className="react-select primary form-control durationselect_package"
                            name="duration_type"
                            value={durationType}
                            onChange={(e) => setDurationType(e.target.value)}
                          >
                            <option value="1">Days</option>
                            <option value="2">Weeks</option>
                            <option value="3">Months</option>
                            <option value="4">Years</option>
                          </select>
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group-custom">
                          <label>Free Trial</label>
                          <FormControl
                            name="free_trial"
                            value={freeTrial}
                            onChange={(e) => setFreeTrial(e.target.value)}
                            placeholder="Enter free trial duration"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            className="form-control"
                            min="0"
                            onKeyPress={(e) => {
                              if (
                                e.key === "-" ||
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="form-group-custom">
                          <label>
                            Free Trial Type <span className="required">*</span>
                          </label>
                          <select
                            className="react-select primary form-control durationselect_package"
                            name="free_trial_type"
                            value={freeTrialType}
                            onChange={(e) => setFreeTrialType(e.target.value)}
                          >
                            <option value="1">Days</option>
                            <option value="2">Weeks</option>
                            <option value="3">Months</option>
                            <option value="4">Years</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-section" ref={featureDetailsRef}>
                    <div className="catalogue-section-header">
                      <h4>
                        <i className="fa fa-list"></i>
                        Feature Details
                      </h4>
                    </div>
                    {featureError && (
                      <div
                        className="error-message"
                        style={{ paddingLeft: "10px" }}
                      >
                        {featureError}
                      </div>
                    )}
                    <div className="section-content">
                      <AddCataloguePackageFeatureDetailsForm
                        featureDetails={featureDetails}
                        setFeatureDetails={setFeatureDetails}
                        addSpecialtyRow={addSpecialtyRow}
                        onChangeTags={onChangeTags}
                        onChangeTier={onChangeTier}
                        tagListOption={tagListOption}
                        couponList={couponList}
                        groupData={groupData}
                        specialtyListOption={specialtyListOption}
                        doctorListOption={doctorListOption}
                        onSpecialityChange={onSpecialityChange}
                        onCallChange={onCallChange}
                        handleAllCheckedFreeDelivery={
                          handleAllCheckedFreeDelivery
                        }
                        deliveryWelcomeNote={deliveryWelcomeNote}
                        setDeliveryWelcomeNote={setDeliveryWelcomeNote}
                        noOfFreeDelivery={noOfFreeDelivery}
                        setNoOfFreeDelivery={setNoOfFreeDelivery}
                        noOfFreeValue={noOfFreeValue}
                        setNoOfFreeValue={setNoOfFreeValue}
                        tags={tags}
                        selectedTiers={selectedTiers}
                        selectedTags={selectedTags}
                        setSelectedTiers={setSelectedTiers}
                        setSelectedTags={setSelectedTags}
                        onCouponAdd={onCouponAdd}
                        onRemoveCoupon={onRemoveCoupon}
                        onGroupAdd={onGroupAdd}
                        onGroupRemove={onGroupRemove}
                        updateClaimField={updateClaimField}
                        updatePolicyField={updatePolicyField}
                        toggleClaimCheckbox={toggleClaimCheckbox}
                        onDoctorChange={onDoctorChange}
                        onDoctorCallChange={onDoctorCallChange}
                        addDoctorRow={addDoctorRow}
                        removeDoctorRow={removeDoctorRow}
                        removeSpecialtyRow={removeSpecialtyRow}
                        processing={processing}
                        packageNameError={packageNameError}
                        packageDurationError={packageDurationError}
                        packagePriceError={packagePriceError}
                        countryError={countryError}
                        claimValueError={claimValueError}
                        bankChargeError={bankChargeError}
                        brokerEmailError={brokerEmailError}
                        ipdClaimValueError={ipdClaimValueError}
                        dashboardUrl={props.dashboardUrl}
                        setDashboardUrl={props.setDashboardUrl}
                        setClaimValueError={setClaimValueError}
                        onCallUnlimitedChange={onCallUnlimitedChange}
                      />
                    </div>
                  </div>

                  <div className="form-actions">
                    <button
                      type="button"
                      className="btn-submit"
                      onClick={onSubmit}
                      disabled={isLoading}
                      isDisabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i>
                          {isEditMode ? "Updating..." : "Submitting..."}
                        </>
                      ) : (
                        <>{isEditMode ? "Update" : "Submit"}</>
                      )}
                    </button>
                  </div>
                </form>
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};
export default CreateCataloguePackageDetailsForm;
